import type { ComponentProps } from "react"
import {
  TRAVELTIME_START_POINT_PIN_BODY_PATH,
  TRAVELTIME_START_POINT_PIN_DOT_PATH,
  TRAVELTIME_START_POINT_PIN_FILL,
  TRAVELTIME_START_POINT_PIN_HOLE_PATH,
  TRAVELTIME_START_POINT_PIN_OUTLINE,
  TRAVELTIME_START_POINT_RINGS,
} from "@/v2-ui/icon/custom/traveltimeStartPoint/traveltimeStartPoint.constants"

/** The ring's dotted outline on the 32 px grid: round dots a dot apart. */
const UNSET_RING_DASH = "0.1 3"
/** The unset ring's fill, a fraction of the set ring's, so the grey reads as a slot, not a reach. */
const UNSET_RING_FILL_SCALE = 0.4
/** The pin and the dotted outline fade with the ring, so the whole slot sits back. */
const UNSET_OPACITY = 0.55

/**
 * The start point before it is set: the single-ring glyph with the ring
 * in one muted colour (`currentColor`, the caller's grey) under a dotted
 * outline, the pin as on the set glyph but faded with it. The ring's fill
 * is a fraction of the set ring's and the whole glyph sits at reduced
 * opacity, so the slot reads as a slot and nothing moves when the point
 * lands, it only comes into colour.
 */
export default function TraveltimeStartPointUnset(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props
  const [ring] = TRAVELTIME_START_POINT_RINGS[1]

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity={UNSET_OPACITY}
      {...svgProps}
    >
      <path
        d={ring.d}
        fill={fill}
        fillOpacity={ring.fillOpacity * UNSET_RING_FILL_SCALE}
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray={UNSET_RING_DASH}
      />
      <path
        d={TRAVELTIME_START_POINT_PIN_DOT_PATH}
        fill={TRAVELTIME_START_POINT_PIN_FILL}
        stroke={TRAVELTIME_START_POINT_PIN_OUTLINE}
      />
      <path
        d={TRAVELTIME_START_POINT_PIN_BODY_PATH}
        fill={TRAVELTIME_START_POINT_PIN_FILL}
        stroke={TRAVELTIME_START_POINT_PIN_OUTLINE}
        strokeWidth="1.498"
        strokeLinejoin="round"
      />
      <path
        d={TRAVELTIME_START_POINT_PIN_HOLE_PATH}
        fill={TRAVELTIME_START_POINT_PIN_OUTLINE}
      />
    </svg>
  )
}
